import { slugToTitleCase } from 'config/libraries';
import { MenuInformasi } from 'master-data/menu';
import React, { useState, useEffect } from 'react'

export const Banner = ({slug}) => {
    const [DataMenu, setDataMenu] = useState([]);
   
    useEffect(() => {
        const convertedSlug = slugToTitleCase(slug);
        for (let i = 0; i < MenuInformasi.length; i++) {
            if (convertedSlug === MenuInformasi[i].name) {
                setDataMenu(MenuInformasi[i]);
            }
        }
        return () => {
            setDataMenu([]);
        };
    }, [slug]);

    return (
        <>
        <div className="jl_single_style4">
                <div className="Cwca3ta" style={{backgroundImage: 'url("/img/banner-informasi-2.png")'}} ></div>
            {/* <div className="single_content_header single_captions_overlay_bottom_image_full_width"> */}
                {/* <div className="image-post-thumb" style={{backgroundImage: 'url("/img/banner-informasi-2.jpg")'}} ></div> */}
                {/* <div className="single_post_entry_content_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="single_post_entry_content">
                                    <span className="meta-category-small">
                                        <a className="post-category-color-text" style={{background: '#62ce5c'}} href="#!">{(DataMenu != null) ? DataMenu.name : ''}</a>
                                    </span> 
                                    <h1 className="single_post_title_main">{(DataMenu != null) ? DataMenu.description : ''}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            {/* </div> */}
        </div>
        </>
    )
};